import { TECH_DATA } from "./tech.data";

const INITIAL_STATE = {
  techs: TECH_DATA,
};

const techReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default techReducer;
